export { default as Icon } from './Icon.vue';
export { IconSize } from './icon.constants';
